import type { Question } from 'Types/Questions'

export const storeToLocalStorage = (
  isMunicipality: boolean,
  localStorageItemName: string,
  question: Question,
  answerKey: string,
  rangeValue: number,
  selectedBfsId?: number
) => {
  let perviousAnsweredQuestions: any = {}
  let prevQuestionsString
  try {
    prevQuestionsString = localStorage.getItem(localStorageItemName)
  } catch {
    console.log('cannot access local storage')
  }

  if (prevQuestionsString) {
    perviousAnsweredQuestions = JSON.parse(prevQuestionsString)
    if (perviousAnsweredQuestions[question.id]) {
      // Already answered this question for either muni or national
      if (isMunicipality && selectedBfsId) {
        // Already answered this question for a municipality
        perviousAnsweredQuestions[question.id][answerKey] = {
          ...perviousAnsweredQuestions[question.id][answerKey],
          [selectedBfsId]: rangeValue,
        }
      } else {
        perviousAnsweredQuestions[question.id][answerKey] = rangeValue
      }
    } else {
      // never answered this question but answered others
      if (isMunicipality && selectedBfsId) {
        perviousAnsweredQuestions[question.id] = {
          [answerKey]: { [selectedBfsId]: rangeValue },
        }
      } else {
        perviousAnsweredQuestions[question.id] = { [answerKey]: rangeValue }
      }
    }
  } else {
    // never answered anything
    if (isMunicipality && selectedBfsId) {
      perviousAnsweredQuestions[question.id] = {
        [answerKey]: { [selectedBfsId]: rangeValue },
      }
    } else {
      perviousAnsweredQuestions[question.id] = { [answerKey]: rangeValue }
    }
  }

  localStorage.setItem(
    localStorageItemName,
    JSON.stringify(perviousAnsweredQuestions)
  )
}
export const storeSelectedMuniToLocalStorage = (bfsId: number) => {
  localStorage.setItem('swissQuizSelectedBfsId', JSON.stringify(bfsId))
}
export const storeUserId = (userId: string) => {
  localStorage.setItem('swissQuizUserId', userId)
}
